<template>
  <AbsPopup id="ChangeEmail" :title="getTitle" type="confirm" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div v-if="isState === 0" class="popup-body">
        <span>변경하실 이메일을 입력해 주세요</span>
        <ul>
          <li>
            <span><b>이메일</b></span><span class="require">*</span>
          </li>
          <li>
            <UInput type="text" line="bottom" placeholder="" v-model="email" @enter="checkEmail"/>
            <Ubutton text="확인" size="xxsmall" iconSize="xsmall" :state="emailState" @click.native="checkEmail"/>
          </li>
          <li class="error">
            <span :class="emailErrorState">{{ emailError }}</span>
          </li>
        </ul>
      </div>
      <div v-else class="popup-body">
        <span>등록하실 전화번호를 입력해 주세요</span>
        <ul>
          <li>
            <span><b>전화번호</b></span><span class="require">*</span>
          </li>
          <li>
            <UInput type="text" line="bottom" placeholder="" v-model="phone" @enter="checkEmail"/>
            <Ubutton text="확인" size="xxsmall" iconSize="xsmall" :state="emailState" @click.native="checkEmail"/>
          </li>
          <li class="error">
            <span :class="phoneErrorState">{{ phoneError }}</span>
          </li>
        </ul>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import {isEmail, numberToPhone, phoneToNumber} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.email = this.option.param.email
    this.phone = this.option.param.phone
    this.$emit('loading', false)
  },
  beforeDestroy () {
  },
  data () {
    return {
      email: '',
      emailState: 'disable',
      emailError: '',
      emailErrorState: 'require',
      emailButtonState: 'disable',
      phone: '',
      phoneError: '',
      phoneErrorState: 'require'
    }
  },
  name: 'ChangeAccount',
  watch: {
    email (val) {
      if (isEmail(val)) {
        this.emailError = '정상적인 이메일이 아닙니다.'
        this.emailErrorState = 'require'
        this.emailState = 'disable'
      } else {
        this.emailError = ''
        this.emailErrorState = 'require'
        this.emailState = 'deactive'
      }
    },
    phone (val) {
      if (val === null || val === undefined) {
        this.phoneError = ''
        this.phoneErrorState = 'require'
        this.emailState = 'deactive'
      } else {
        this.phone = numberToPhone(val)
      }
    }
  },
  computed: {
    getTitle () {
      return (this.isState === 0) ? '이메일변경' : '전화번호등록'
    },
    isState () {
      return this.option.param.state
    },
    buttonList () {
      return [
        {name: '취소하기', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '인증하기', state: this.emailButtonState, click: this.submit}
      ]
    }
  },
  methods: {
    checkEmail () {
      if (this.emailState === 'deactive') {
        if (this.isState === 0) {
          this.$http.post('/api/auth/isEmail', {email: this.email}).then((e) => {
            if (e.success) {
              if (e.data) {
                this.emailError = '이미 사용중인 이메일 입니다.'
                this.emailErrorState = 'require'
                this.emailState = 'deactive'
                this.emailButtonState = 'disable'
              } else {
                this.emailError = '사용 가능한 이메일 입니다.'
                this.emailErrorState = 'active'
                this.emailState = 'active'
                this.emailButtonState = 'in-active'
              }
            } else {
              // 통신에러?
            }
          })
        } else {
          if (this.phone !== '' && this.phone !== null) {
            this.$http.post('/api/auth/isPhone', {phone: phoneToNumber(this.phone)}).then((e) => {
              console.log(e)
              if (e.success) {
                if (e.data) {
                  this.phoneError = '이미 사용중인 전화번호 입니다.'
                  this.phoneErrorState = 'require'
                  this.phoneState = 'deactive'
                  this.emailButtonState = 'disable'
                } else {
                  this.phoneError = '사용 가능한 전화번호 입니다.'
                  this.phoneErrorState = 'active'
                  this.phoneState = 'active'
                  this.emailButtonState = 'in-active'
                }
              } else {
                // 통신에러?
              }
            })
          }
        }
      }
    },
    submit () {
      if (this.isState === 0) {
        this.$emit('submit', this.email)
      } else {
        this.$emit('submit', phoneToNumber(this.phone))
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#ChangeEmail {
  padding: 10px 0;
  width: 500px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  margin: 5px 0px;
  padding: 10px;
  align-items: center;
}
.popup-body ul {
  padding-top: 30px;
  list-style: none;
  display: flex;
  width: 400px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.popup-body ul .input {
  flex: 1;
  height: 100%;
  margin-right: 10px;
}
.popup-body ul .error {
  display: flex;
  height: 35px;
  align-items: center;
  margin-bottom: 10px;
}
.popup-body > ul li {
  display: flex;
  align-items: center;
  height: 30px;
  width: 400px;
}
.popup-body .input {
  flex: 1;
  height: 100%;
  margin-right: 10px;
}
.popup-body button {
  margin-left: 10px;
}
.popup-body div:last-child {
  box-sizing: border-box;
  width: 400px;
}
.popup-body div:last-child.line {
  padding: 20px 0px;
  border: 1px solid var(--line-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ChangeAccount.vue